<script lang="ts">
import { getEnv } from '@monogrid/env'
import { useThrottleFn } from '@vueuse/core'
import axios from 'axios'
import { computed, defineComponent, inject, ref } from 'vue'
import { useRoute } from 'vue-router'

import { useStoreSnapshot } from '@/webgl/composables/useStoreSnapshot'

export default defineComponent({
  name: 'SnapshotButton',
  components: {
    //
  },
  props: {
    //
  },
  setup (props) {
    const isClicked = ref(false)

    const { hasSnapped, snapshotData, updateQRLink } = useStoreSnapshot()
    const route = useRoute()

    const snapshot = inject('takeSnap')

    const isTabletInStore = computed(() => route.query.ver?.includes('store'))

    const generateQR = async () => {
      const uploader = getEnv().UPLOAD_HANDLER_ENDPOINT

      if (snapshotData.value !== undefined && isTabletInStore.value) {
        const result = await axios.post(uploader as string, snapshotData.value, { headers: { 'Content-Type': 'text/plain' } })
        const url = result.data.url

        updateQRLink(url)

        console.log(url)
      }
    }

    const handleSnapshot = () => {
      isClicked.value = !isClicked.value
      snapshot()

      setTimeout(() => {
        isClicked.value = false
        hasSnapped(true)
        generateQR()
      }, 500)
    }

    const throttleSnap = useThrottleFn(handleSnapshot, 1000)

    return {
      throttleSnap,
      hasSnapped,
      handleSnapshot,
      isClicked
    }
  }
})
</script>

<template>
  <button class="snapshot-btn relative h-16 w-16" @click.prevent="throttleSnap()">
    <div
      class="outter-circle absolute inset-1/2 transform -translate-1/2 rounded-full w-20 h-20 border-2 border-white"
      :class="{'scaled-up': isClicked }"
    />
    <div
      class="inner-circle w-full h-full rounded-full"
      :class="{'scaled-down': isClicked }"
    />
  </button>
</template>

<style lang="scss" scoped>
//
.outter-circle {
  transition: transform 0.3s ease;
  will-change: transform;
}

.inner-circle {
  aspect-ratio: 1 / 1;
  backdrop-filter: $backdrop;
  background-color: #ffffff95;
  box-shadow: inset 0 4px 4px #FFFFFFB2, inset 0 2px 4px #FFFFFFB2;
  transition: all 0.3s ease-out;
  will-change: transform;
}

.scaled-down {
  background-color: #ffffff58;
  transform: scale(0.7);
}

.scaled-up {
  transform: translate(-50%, -50%) scale(1.1);
}
</style>
